import { z } from 'zod';

/** UI surface that owns a saved preset namespace (orthogonal to dashboard mode). */
export const FilterPresetSurfaceSchema = z.enum(['overview', 'drilldown']);
export type FilterPresetSurface = z.infer<typeof FilterPresetSurfaceSchema>;
